import { render } from "./DepthMapViewer.vue?vue&type=template&id=3c8b385d&scoped=true"
import script from "./DepthMapViewer.vue?vue&type=script&lang=js"
export * from "./DepthMapViewer.vue?vue&type=script&lang=js"

import "./DepthMapViewer.vue?vue&type=style&index=0&id=3c8b385d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8b385d"]])

export default __exports__